import React, { useEffect, useState } from "react";
import "../styles/Home.css";
import { Link } from "react-router-dom";
import { getProduitsValidesAvecVendeur } from "../services/admin/adminProduitService";
import { getCategoriesWithImages } from "../services/categorieTitreService";
import Produit from "../pages/Produit";

function Home() {
  const [produitsPopulaires, setProduitsPopulaires] = useState([]);
  const [categories, setCategories] = useState([]);

  // 🔄 Langue par défaut
  const [lang, setLang] = useState(localStorage.getItem("lang") || "fr");

  // 🔄 Quand NavBar change la langue
  useEffect(() => {
    const updateLang = () => {
      setLang(localStorage.getItem("lang") || "fr");
    };

    window.addEventListener("langChanged", updateLang);
    return () => window.removeEventListener("langChanged", updateLang);
  }, []);

  // 📌 Textes FR / MG
  const t = {
    heroTitle: lang === "fr" ? "Tsenan’ny Tantsaha" : "Tsenan’ny Tantsaha",
    heroSubtitle:
      lang === "fr"
        ? "Achetez directement auprès des cultivateurs malgaches. Frais et local."
        : "Mividiana mivantana amin'ny tantsaha malagasy. Vokatra vao sy tena eto an-toerana.",
    heroButton: lang === "fr" ? "Voir les produits" : "Hijery vokatra",

    whyTitle: lang === "fr" ? "Pourquoi acheter ici ?" : "Nahoana no hividy eto ?",

    w1Title: lang === "fr" ? "100% tantsaha" : "100% Tantsaha",
    w1Text:
      lang === "fr"
        ? "Produits venant des agriculteurs malgaches"
        : "Vokatra avy amin’ny tantsaha malagasy",

    w2Title: lang === "fr" ? "Sans intermédiaire" : "Tsy misy mpanelanelana",
    w2Text:
      lang === "fr"
        ? "Achat direct auprès des cultivateurs"
        : "Mividy mivantana amin’ny tantsaha",

    w3Title: lang === "fr" ? "Azo antoka sy madio" : "Azo antoka sy madio",
    w3Text:
      lang === "fr"
        ? "Produits naturels et sélectionnés"
        : "Vokatra voajanahary sy voafantina",

    howTitle: lang === "fr" ? "Comment ça marche ?" : "Ahoana ny fandehany ?",

    step1: lang === "fr" ? "1. Parcourez les produits" : "1. Jereo ny vokatra",
    step2: lang === "fr" ? "2. Ajoutez au panier" : "2. Ampidiro ao anaty harona",
    step3: lang === "fr" ? "3. Passez la commande" : "3. Manaova kaomandy",
    step4: lang === "fr" ? "4. Recevez directement" : "4. Raiso avy hatrany",
  };

  // 🔄 Charger produits + catégories
  useEffect(() => {
    const fetchData = async () => {
      try {
        const produits = await getProduitsValidesAvecVendeur();
        setProduitsPopulaires(Array.isArray(produits) ? produits.slice(0, 4) : []);

        const categoriesData = await getCategoriesWithImages();
        setCategories(categoriesData || []);
      } catch (error) {
        console.error("Erreur chargement données :", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="home-container">
      {/* === HERO === */}
      <section className="hero">
        <div className="hero-text">
          <h1>{t.heroTitle}</h1>
          <p>{t.heroSubtitle}</p>

          <Link to="/produits">
            <button>{t.heroButton}</button>
          </Link>
        </div>
      </section>

      {/* Produits (ton composant) */}
      <Produit />

      {/* === POURQUOI ACHETER === */}
      <section className="why-buy">
        <h2>{t.whyTitle}</h2>

        <div className="reasons">
          <div className="reason">
            <img src="/icons/plante.png" alt="" />
            <h4>{t.w1Title}</h4>
            <p>{t.w1Text}</p>
          </div>

          <div className="reason">
            <img src="/icons/mpamboly.png" alt="" />
            <h4>{t.w2Title}</h4>
            <p>{t.w2Text}</p>
          </div>

          <div className="reason">
            <img src="/icons/check.png" alt="" />
            <h4>{t.w3Title}</h4>
            <p>{t.w3Text}</p>
          </div>
        </div>
      </section>

      {/* === COMMENT ÇA MARCHE === */}
      <section className="how-it-works">
        <h2>{t.howTitle}</h2>

        <div className="steps">
          <div className="step">
            <img src="/icons/step1.png" alt="" />
            <p>{t.step1}</p>
          </div>

          <div className="step">
            <img src="/icons/panier.png" alt="" />
            <p>{t.step2}</p>
          </div>

          <div className="step">
            <img src="/icons/commande.png" alt="" />
            <p>{t.step3}</p>
          </div>

          <div className="step">
            <img src="/icons/recevez.png" alt="" />
            <p>{t.step4}</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
